import { Component, Input, OnInit } from '@angular/core';
import { GroupClassModel } from '@bayclubs/group-classes-employee-api';
import { gcManagementEnumerations } from 'src/app/interfaces/interfaces.module';

@Component({
    selector: '[app-group-classes-list-row]',
    templateUrl: './group-classes-list-row.component.html',
    styleUrls: ['./group-classes-list-row.component.scss'],
    standalone: false
})
export class GroupClassesListRowComponent implements OnInit {
    @Input()
    public item: GroupClassModel;

    constructor() {}

    ngOnInit() {}

    public isItemCancelled(): boolean {
        return this.item.status.code === gcManagementEnumerations.GroupClassStatus.cancelled.code;
    }
}
